import { User } from '@marketmuse/config/types/papi';

export const initialState: Partial<User> = {};
